export const PROMPT_DELETE_EXAMINER =
  "Êtes-vous sûr de vouloir supprimer cet examinateur ?";
export const PROMPT_DELETE_ALL_DATA =
  "Êtes-vous sûr de vouloir supprimer TOUTES les données ?";
export const PROMPT_DELETE_STUDENT =
  "Êtes-vous sûr de vouloir supprimer cet élève ?";
